<template>
<div class="modal-erro">

	<!-- MODAL QUANDO O TOKEN EXPIRA -->
	<modal index="11189"  ref="modalLogin">
		<form @submit.prevent="validaLogin">
			<div class="row">
				<div class="col-md-12">
					<h4>{{titulo.titulo.toUpperCase()}}</h4>
				</div>
			</div>

			<hr style="margin-top: 0px; margin-bottom: 0px">

			<div class="row">
				<div class="col-xs-12">
					<div class="row" style="margin-top: 16px;margin-bottom: 16px">
						<div class="col-xs-4 text-center">
							<div v-show="foto != ''">
								<img :src="foto" class="img-circle" style="margin-left: 8px;border:2px solid #999; height: 130px;" />
							</div>

							<div v-show="foto == ''">
								<div class="div-nome">
									<p class="div-texto">{{nomeReduzido}}</p>
								</div>
								
							</div>
						</div>
						<div class="col-xs-8">
							<h3 style="margin-top: 0px">
								{{nome}}, {{_traducao('global', 'suaSessaoExpirou')}}
							</h3>

							<h3>
								{{_traducao('global', 'digiteSuaSenhaParaRenovala')}}
							</h3>

							<div class="form-group">
								<label>{{_traducao('menuAGnovoUsuario', 'menuAGlogin')}}: </label> 
								<input v-model="login" type="text" disabled="disabled" class="form-control input-sm" />
							</div>
							<div class="form-group" :class="{'has-error' : erroSenha != ''}">
								<label>{{_traducao('menuAGnovoUsuario', 'menuAGsenha')}}: </label> 
								<input v-model="senha" type="password" class="form-control input-sm" />
								<p class="help-block" v-show="erroSenha != ''">{{erroSenha}}</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<hr style="margin-top: 0px; margin-bottom: 10px">

			<div class="row">
				<div class="col-xs-12">
					<a href="#" class="btn btn-default" type="button" @click.prevent="clickSair()">
						<i class="icon icon-left fa-fw" style="float: left;margin-right: 5px;margin-top: 2px;"></i>
						{{_traducao('global','sair').toUpperCase()}}
					</a>
					<button class="btn btn-success pull-right">
						{{_traducao('login','entrar').toUpperCase()}}
						<i class="fa fa-fw fa-check"></i></button>
				</div>
			</div>	
		</form>
	</modal>

	<!-- MODAL QUANDO GERA UM ERRO -->
	<modal index="11189" ref="modalErro" name="modal-erro">
		<div class="row">
			<div class="col-md-12 text-danger">
				<button type="button" class="close" @click="$refs.modalErro.modalHide()">
					<span aria-hidden="true">&times;</span></button>
					<h4> <i :class="'fa' + titulo.icone" aria-hidden="true"></i> {{titulo.titulo}}</h4>
			</div>
		</div>

		<hr style="margin-top: 0px; margin-bottom: 0px">

		<div class="row">
			<div class="col-md-12">
				<h4 v-html="titulo.texto">
				</h4>
			</div>
			
			<div class="col-xs-12">
				<iframe id="iframe" style="width: 100%;height: 400px;"></iframe>
			</div>

		</div>

		<hr style="margin-top: 0px; margin-bottom: 10px">

		<div class="row">
			<div class="col-xs-12">
				<button type="button" class="btn btn-default pull-right" data-dismiss="modal" aria-label="Close">
					<i class="fa fa-times"></i> {{_traducao('global','fechar').toUpperCase()}}
				</button>
			</div>
		</div>	
	</modal>
</div>
</template>

<script>

export default {

	data () {
		return {
			erroTexto: "",

			login: "",
			senha: "",
			erroSenha: "",

			nome: "",
			nomeReduzido: "",
			foto: "",

			titulo: {
				icone: "fa-frown-o",
				texto: "",
				titulo: "",
			},
		}
	},

	mounted () {
		this.eventos();
	},

	methods: {

		eventos () {
			bus.$on('modal-erro-show', (obj) => {
				bus.$emit('load-out');
				this.validaErro(obj);
			})
		},

		validaErro (erro){
			
			// token expirado
			if(erro.status == 408){
				this.$refs.modalLogin.modalShow(40)// levanto modal para logar dinovo
				//this._exibeModal('modal-login', 40); 
				this.titulo.titulo = this._traducao('global', 'sessaoExpirada');
				this.login = $sessao.getLogin();
				this.nome = $sessao.getNome().split(" ")[0];

				var nome = $sessao.getNome().split(" ");

				if(nome.length > 1){
					this.nomeReduzido = nome[0].substring(0,1) + nome[1].substring(0,1);
				} else {
					this.nomeReduzido = nome[0].substring(0,2);
				}

				if ($sessao.getFoto() != "") {
					//return "http://104.236.64.199/police/ws/foto/4e677897890bf6ace97b7a1abc9b42cf.jpg";
					this.foto = this._foto
				}
			} else if(erro.status != 0) {

				this._escondeModal('modal-alterar-senha');
				
				this.$nextTick(() => {
					if(!_.isNil(document)){
						var iframe = document.getElementById('iframe');
						if(!_.isNil(iframe)){
							iframe.contentWindow.document.body.innerHTML = erro.responseText; 
							this.titulo.texto =  this._traducao('global', 'algoDeuErrado');
							this.titulo.texto += "<br/><br/>" + this._traducao('global', 'aconteceuUmProbleminha');
							this.titulo.texto += "<br/><br/>" + this._traducao('global', 'seOErroPersistir');

							this.titulo.titulo = "OPS!"
							this.$refs.modalErro.modalShow(80)
						}		
					}
				}) 
			}
		},

		validaLogin: function(){

			this.erro = false

			if(this.senha.trim() == ''){

				this.erroSenha = this._traducao('global', 'vcTemQueDigitarSenha');
				return false;
			} else {
				this.erroSenha = "";
			}

			this.textoLoad = ""
			this.exibirLoad = true

			bus.$emit('load-in', {text: this._traducao('login','entrando').toUpperCase()})

			var data = {
				login: this.login,
				senha: this.senha,
				
			}
			
			this._httpPost('/Usuario/logar', data, (retorno) => {
				bus.$emit('load-out')
				this.exibirLoad = false
				if(retorno._request && retorno._status && retorno.token.trim() != ""){
					this.erro = false
					bus.$emit('exibir-notificacao', {type: 'success', text : this._traducao('global', 'sessaoAtualizada')});
					$sessao.setSessao(retorno.token, retorno.privilegios, retorno.area);
					this.$refs.modalLogin.modalHide()
				} else {

					this.erroSenha = this._traducao('global', 'senhaInvalida')
					bus.$emit('exibir-notificacao', {type: 'danger', text : this.erroSenha})
				}
			})
		},

		clickSair: function () {
			this.$refs.modalLogin.modalHide()
			$sessao.remove()
			this.$router.replace({ name: 'login' })
		},

	}
}
</script>